import React from 'react';

const Resource = ({ basis, source }) => (
  <small className="text-muted">
    {basis}
    <br />
    {source}
  </small>
);

export default Resource;
